import React, { useState, useEffect, useRef } from 'react';
import BASE_URL from "../../../../config/config";
import { useNavigate } from 'react-router-dom';
import JobDocumentService from "../../Controller/JobDocumentController";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import JobService from "../../Controller/JobController";
import { handleSubmit } from "../../Controller/CreateJobDocumentController";

function JobDocumentPage({ JobID }) {

    const navigate = useNavigate();

    const redirectCallback = () => {
        navigate('/');
    };

    JobID = localStorage.getItem('JobID');

    const CompanyID = localStorage.getItem("CompanyID");

    const [JobDocuemntList, setJobDocumentData] = useState([]);
    const [errors, setErrors] = useState({});
    const [isClosed, SetIsClosed] = useState("0");

    const tableRef = useRef();
    const fileInputRef = useRef(null);

    const [formData, setFormData] = useState({
        IssueID: JobID,
        FileName: '',
        Path: '',
        Name: '',
        Description: '',
        File: null,
        CompanyDocument: 0
    });

    const initDataTable = () => {

        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }

        $(tableRef.current).DataTable({
            paging: true,
            searching: true,
            info: true,
            order: [[0, 'desc']],
        });
    };

    const fetchJobDetail = async () => {

        try {

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(
                    redirectCallback,
                    JobID
                );

                SetIsClosed(jobDetail[0].IsCompleted);
            }

        } catch (error) {

            console.error('Error fetching agreement details:', error);
        }
    };

    const fetchJobDocument = async () => {

        try {

            const data = await JobDocumentService.GetAllJobDocuments(
                redirectCallback,
                JobID
            );

            setJobDocumentData(data);

        } catch (error) {

            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {

        SetIsClosed(localStorage.getItem("Closed"));

        fetchJobDetail();

        if (JobDocuemntList.length > 0) {
            initDataTable();
        }

    }, [JobDocuemntList]);

    useEffect(() => {

        if (JobID > 0) {
            fetchJobDocument();
        }
        else {
            setJobDocumentData([]);
        }

    }, [JobID]);

    // OPEN FILE PICKER
    const handleCreateJobDocumentClick = () => {

        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // DIRECT UPLOAD
    const handleDirectFileUpload = async (event) => {

        const file = event.target.files[0];

        if (!file) return;

        const uploadData = {
            IssueID: JobID,
            FileName: '',
            Path: file.name,
            Name: file.name,
            Description: '',
            File: file,
            CompanyDocument: 0,
            DocID: 0
        };

        try {

            await handleSubmit(
                event,
                uploadData,
                setFormData,
                setErrors,
                () => { },
                () => { }
            );

            await fetchJobDocument();

            Swal.fire({
                icon: 'success',
                title: 'Uploaded',
                text: 'Document uploaded successfully',
                timer: 1500,
                showConfirmButton: false
            });

        } catch (error) {

            console.error('Upload Error:', error);

            Swal.fire({
                icon: 'error',
                title: 'Upload Failed',
                text: 'Something went wrong'
            });
        }

        // RESET INPUT
        event.target.value = '';
    };

    const handleDeleteClick = async (event, ID) => {

        event.stopPropagation();

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {

            if (result.isConfirmed) {

                try {

                    await JobDocumentService.DeleteJobDocument(
                        redirectCallback,
                        ID
                    );

                    if ($.fn.DataTable.isDataTable(tableRef.current)) {
                        $(tableRef.current).DataTable().destroy();
                    }

                    fetchJobDocument();

                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );

                } catch (error) {

                    console.error('Error deleting job:', error);

                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };

    const getFileIcon = (fileName) => {

        const ext = fileName.split('.').pop().toLowerCase();

        if (ext === 'pdf')
            return 'icofont-file-pdf text-danger';

        if (['jpg', 'jpeg', 'png'].includes(ext))
            return 'icofont-image text-warning';

        if (['doc', 'docx'].includes(ext))
            return 'icofont-file-word text-primary';

        if (['xls', 'xlsx'].includes(ext))
            return 'icofont-file-excel text-success';

        return 'icofont-file-alt text-secondary';
    };

    const getFileExtension = (fileName) => {

        const index = fileName.lastIndexOf('.');

        return index !== -1
            ? fileName.substring(index)
            : '';
    };

    const truncateText = (text, maxLength = 10) => {

        if (!text) return '';

        return text.length > maxLength
            ? text.slice(0, maxLength) + '...'
            : text;
    };

    const handleDownload = async (e, docuemnt) => {

        e.stopPropagation();

        const ext = getFileExtension(docuemnt.FileName);

        const customName = `${docuemnt.Name}${ext}`;

        try {

            const response = await fetch(
                `${BASE_URL}/uploads/${CompanyID}/Job/Document/${docuemnt.FileName}`
            );

            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");

            link.href = url;
            link.download = customName;

            document.body.appendChild(link);

            link.click();

            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {

            console.error("Download failed:", error);
        }
    };

    return (

        <div className="p-2">

            <style>
                {`

                .mobile-add-btn {
                    height: 48px;
                    border-radius: 14px;
                    padding: 0 18px;
                    font-size: 16px;
                    font-weight: 600;
                }

                .mobile-doc-card {
                    background: #fff;
                    border-radius: 18px;
                    padding: 16px;
                    margin-bottom: 14px;
                    box-shadow: 0 3px 12px rgba(0,0,0,0.08);
                    border: 1px solid #edf0f2;
                    transition: all 0.2s ease;
                }

                .mobile-doc-card:active {
                    transform: scale(0.98);
                }

                .mobile-doc-left {
                    display: flex;
                    align-items: center;
                    flex: 1;
                }

                .mobile-doc-icon-wrapper {
    width: 95px;
    height: 95px;
    min-width: 95px;
    border-radius: 18px;
    background: #f5f7fb;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    overflow: hidden;
}

                .mobile-doc-icon {
    font-size: 38px !important;
}
                .mobile-doc-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 18px;
}

                .mobile-doc-title {
                    font-size: 15px;
                    font-weight: 600;
                    color: #1f2937;
                    margin-bottom: 5px;
                    word-break: break-word;
                }

                .mobile-doc-desc {
                    font-size: 12px;
                    color: #6b7280;
                }

                .mobile-delete-btn {
                    width: 46px;
                    height: 46px;
                    min-width: 46px;
                    border-radius: 14px;
                    border: none;
                    background: #ffe9e9;
                    color: #dc3545;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-left: 12px;
                }

                .mobile-delete-btn i {
                    font-size: 24px;
                }

                .mobile-empty-state {
                    background: #fff;
                    border-radius: 16px;
                    padding: 40px 20px;
                    text-align: center;
                    color: #888;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
                }

                .desktop-table-view {
                    display: block;
                }

                .mobile-card-view {
                    display: none;
                }

                @media (max-width: 768px) {

                    .desktop-table-view {
                        display: none;
                    }

                    .mobile-card-view {
                        display: block;
                    }
                }

                `}
            </style>

            {/* HIDDEN FILE INPUT */}
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleDirectFileUpload}
            />

            {/* ADD BUTTON */}
            <div className="row mb-3">

                <div
                    className="col-sm-12"
                    style={{ textAlign: "right" }}
                >

                    <button
                        className='btn btn-primary mobile-add-btn'
                        onClick={handleCreateJobDocumentClick}
                        disabled={isClosed === '1' || isClosed === 1}
                    >
                        <i
                            className="icofont-plus"
                            style={{
                                fontSize: "20px",
                                marginRight: "6px"
                            }}
                        ></i>

                        Add Document
                    </button>

                </div>

            </div>

            {/* MOBILE VIEW */}

            {/* MOBILE VIEW */}
            <div className="mobile-card-view">

                {JobDocuemntList.length === 0 && (

                    <div className="mobile-empty-state">

                        <i
                            className="icofont-file-document"
                            style={{
                                fontSize: "50px",
                                marginBottom: "10px",
                                display: "block",
                                color: "#c7c7c7"
                            }}
                        ></i>

                        No documents available

                    </div>
                )}

                {/* GRID VIEW */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))",
                        gap: "12px",
                        width: "100%"
                    }}
                >

                    {JobDocuemntList.map((docuemnt, index) => (

                        <div
                            key={index}
                            onClick={(e) => handleDownload(e, docuemnt)}
                            style={{
                                width: "100%",
                                background: "#fff",
                                borderRadius: "18px",
                                padding: "10px",
                                boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
                                border: "1px solid #edf0f2",
                                cursor: "pointer",
                                position: "relative"
                            }}
                        >

                            {/* DELETE BUTTON */}
                            <button
                                onClick={(e) => handleDeleteClick(e, docuemnt.DocID)}
                                style={{
                                    position: "absolute",
                                    top: "6px",
                                    right: "6px",
                                    border: "none",
                                    background: "#ffe9e9",
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "8px",
                                    color: "#dc3545",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 2
                                }}
                            >
                                <i
                                    className="icofont-ui-delete"
                                    style={{ fontSize: "14px" }}
                                ></i>
                            </button>

                            {/* IMAGE / ICON */}
                            <div
                                style={{
                                    width: "100%",
                                    height: "110px",
                                    borderRadius: "14px",
                                    overflow: "hidden",
                                    background: "#f5f7fb",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "10px"
                                }}
                            >

                                {['jpg', 'jpeg', 'png'].includes(
                                    docuemnt.FileName.split('.').pop().toLowerCase()
                                ) ? (

                                    <img
                                        src={`${BASE_URL}/uploads/${CompanyID}/Job/Document/${docuemnt.FileName}`}
                                        alt="doc"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                        }}
                                    />

                                ) : (

                                    <i
                                        className={getFileIcon(docuemnt.FileName)}
                                        style={{ fontSize: "55px" }}
                                    ></i>
                                )}

                            </div>

                            {/* FILE NAME */}
                            <div
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                    marginBottom: "3px",
                                    wordBreak: "break-word",
                                    textAlign: "center"
                                }}
                            >
                                {truncateText(docuemnt.FileName, 18)}
                            </div>

                            {/* DESCRIPTION */}
                            <div
                                style={{
                                    fontSize: "10px",
                                    color: "#6b7280",
                                    textAlign: "center"
                                }}
                            >
                                {docuemnt.Description || "Tap to download"}
                            </div>

                        </div>
                    ))}

                </div>

            </div>

            {/* DESKTOP VIEW */}
            <div className="desktop-table-view">

                <div style={{ maxHeight: "460px", overflow: "auto" }}>

                    <table
                        ref={tableRef}
                        className="table table-hover align-middle"
                        style={{ width: '100%' }}
                    >

                        <thead className="table-light">

                            <tr>
                                <th>File</th>
                                <th>Description</th>
                                <th width="120">Action</th>
                            </tr>

                        </thead>

                        <tbody>

                            {JobDocuemntList.map((docuemnt, index) => (

                                <tr
                                    key={index}
                                    onClick={(e) => handleDownload(e, docuemnt)}
                                    style={{ cursor: "pointer" }}
                                >

                                    <td>

                                        <div className="d-flex align-items-center">

                                            <div
                                                style={{
                                                    width: "50px",
                                                    height: "50px",
                                                    borderRadius: "10px",
                                                    overflow: "hidden",
                                                    background: "#f5f7fb",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    marginRight: "12px"
                                                }}
                                            >

                                                {['jpg', 'jpeg', 'png'].includes(
                                                    docuemnt.FileName.split('.').pop().toLowerCase()
                                                ) ? (

                                                    <img
                                                        src={`${BASE_URL}/uploads/${CompanyID}/Job/Document/${docuemnt.FileName}`}
                                                        alt="doc"
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover"
                                                        }}
                                                    />

                                                ) : (

                                                    <i
                                                        className={getFileIcon(docuemnt.FileName)}
                                                        style={{ fontSize: "26px" }}
                                                    ></i>
                                                )}

                                            </div>

                                            <div>
                                                <div style={{ fontWeight: 600 }}>
                                                    {truncateText(docuemnt.FileName, 40)}
                                                </div>
                                            </div>

                                        </div>

                                    </td>

                                    <td>
                                        {docuemnt.Description || "-"}
                                    </td>

                                    <td>

                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={(e) =>
                                                handleDeleteClick(e, docuemnt.DocID)
                                            }
                                            disabled={isClosed === '1' || isClosed === 1}
                                        >
                                            <i className="icofont-ui-delete"></i>
                                        </button>

                                    </td>

                                </tr>
                            ))}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>
    );
}

export default JobDocumentPage;